import { Injectable } from '@angular/core';

/** Base URL of the hosted Cockpit user manual. */
export const MANUAL_BASE_URL = 'https://cockpit-manual.yukkalab.com/';

/** Named window target so repeated opens reuse the same tab. */
export const MANUAL_WINDOW_TARGET = 'cockpit-guide';

/**
 * Single source of truth for opening the hosted Cockpit user manual.
 * Centralised so the URL can't drift across the callers that link to it.
 */
@Injectable({ providedIn: 'root' })
export class CockpitManualService {
  /** Open the manual in a dedicated tab, optionally jumping to a section anchor. */
  open(anchor = ''): void {
    const href = MANUAL_BASE_URL + (anchor ? `#${anchor}` : '');
    window.open(href, MANUAL_WINDOW_TARGET);
  }
}
